import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About TiLimousine | Luxury Chauffeur Service</title>
        <meta name="description" content="Discover TiLimousine's commitment to excellence in luxury transportation. Learn about our professional drivers, premium fleet, and dedication to customer satisfaction." />
        <link rel="canonical" href="https://tilimousine.com/about" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About TiLimousine",
            "description": "Learn about TiLimousine's commitment to excellence in luxury transportation.",
            "url": "https://tilimousine.com/about",
            "publisher": {
              "@type": "Organization",
              "name": "TiLimousine",
              "url": "https://tilimousine.com"
            }
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-black">
        <Navbar />
        <main className="container mx-auto px-4 py-20">
          <h1 className="text-4xl md:text-5xl font-cinzel text-gold text-center mb-12">
            Premier Luxury Transportation Service
          </h1>
          
          <div className="max-w-4xl mx-auto text-white space-y-8">
            <section className="prose prose-invert max-w-none">
              <h2 className="text-2xl font-cinzel text-gold mb-4">Our Story</h2>
              <p className="text-lg leading-relaxed">
                TiLimousine has been at the forefront of luxury transportation, 
                setting new standards in premium chauffeur services. Our commitment to 
                excellence and attention to detail has made us the preferred choice for 
                discerning clients seeking the finest in ground transportation.
              </p>
            </section>

            <section className="prose prose-invert max-w-none">
              <h2 className="text-2xl font-cinzel text-gold mb-4">Our Mission</h2>
              <p className="text-lg leading-relaxed">
                We strive to provide an unparalleled luxury transportation experience, 
                combining professional service, premium vehicles, and meticulous attention 
                to detail. Our goal is to exceed expectations and create memorable 
                journeys for every client.
              </p>
            </section>

            <section className="prose prose-invert max-w-none">
              <h2 className="text-2xl font-cinzel text-gold mb-4">Why Choose Us</h2>
              <ul className="list-none space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-gold">•</span>
                  <span>Professional, experienced chauffeurs</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-gold">•</span>
                  <span>Premium, well-maintained fleet</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-gold">•</span>
                  <span>24/7 customer support</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-gold">•</span>
                  <span>Punctual and reliable service</span>
                </li>
              </ul>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default About; 